import type { ISerialize } from '@/objects/ISerialize';
import type { SetContestantStatusCancelledAction } from './../enums/SetContestantStatusCancelledAction';

export class SetContestantStatusCancelledRequest implements ISerialize {
    public Action: SetContestantStatusCancelledAction;

    public ContestantId: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Action?: SetContestantStatusCancelledAction; ContestantId?: number }) {
        this.Action = values.Action ?? 'DoNothing';

        this.ContestantId = values.ContestantId ?? 0;
    }

    public serialize(): string {
        return (
            '{' +
            `"Action": ${this.Action == 'DoNothing' ? 0 : this.Action == 'SetCancelled' ? 1 : this.Action == 'SetCancelledAndDeleteOrderLines' ? 2 : 0}` +
            ',' +
            `"ContestantId": ${JSON.stringify(this.ContestantId)}` +
            '}'
        );
    }

    /**
     * Creates an instance of SetContestantStatusCancelledRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Action?: SetContestantStatusCancelledAction;
        ContestantId?: number;
    }): SetContestantStatusCancelledRequest {
        return new SetContestantStatusCancelledRequest(values);
    }

    public static _FromServerJson(json: any): SetContestantStatusCancelledRequest {
        return new SetContestantStatusCancelledRequest({
            Action:
                json.Action == 0
                    ? 'DoNothing'
                    : json.Action == 1
                      ? 'SetCancelled'
                      : json.Action == 2
                        ? 'SetCancelledAndDeleteOrderLines'
                        : 'DoNothing',
            ContestantId: json.ContestantId,
        });
    }

    /**
     * Creates an instance of SetContestantStatusCancelledRequest from another instance of SetContestantStatusCancelledRequest.
     * @param other The SetContestantStatusCancelledRequest you want to clone
     * @returns A cloned SetContestantStatusCancelledRequest
     */
    public static FromOther(other: SetContestantStatusCancelledRequest): SetContestantStatusCancelledRequest {
        return SetContestantStatusCancelledRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SetContestantStatusCancelledRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'SetContestantStatusCancelledRequest';
}
